import React from 'react'
import Header from '../components/Header'
import AboutUs from '../components/About'
import Footer from '../components/Footer'
export default function Aboutus() {
  return (
    <div>
      <Header></Header>
      <AboutUs></AboutUs>
      <Footer></Footer>
    </div>
  )
}
